const actions = {
    FETCH_ADMISSION_SLIDES: 'FETCH_ADMISSION_SLIDES',
    FETCH_ADMISSION_SLIDE: 'FETCH_ADMISSION_SLIDE',
    RESET_ADMISSION_SLIDE: 'RESET_ADMISSION_SLIDE',

    fetchAdmissionSlidesAction: (data) => {
        return {
            type: actions.FETCH_ADMISSION_SLIDES,
            data: data
        };
    },
    fetchAdmissionSlideAction: (data) => {
        return {
            type: actions.FETCH_ADMISSION_SLIDE,
            data: data
        };
    },
    resetAdmissionSlideFormAction: () => {
        return {
            type: actions.RESET_ADMISSION_SLIDE,
            data: null
        };
    }
};

export default actions;
